import React, { FC, useCallback } from 'react';
import { SEARCH_STRING_LOCALIZATION_KEY } from '@next/shared';
import { StyledCreateAccountButton } from './styled';
import { useLocalizationContext } from 'shared/lib/localization';

interface CreateAccountProps {
    signUpUrl: string;
    testId: string;
}

export const CreateAccount: FC<CreateAccountProps> = ({ signUpUrl, testId }) => {
    const { language } = useLocalizationContext();

    const redirectToSignUp = useCallback(() => {
        window.location.href = `${signUpUrl}?${SEARCH_STRING_LOCALIZATION_KEY}=${language}`;
    }, [signUpUrl]);

    return (
        <StyledCreateAccountButton
            color="#1DA189"
            localizationKey="Landing.Unauthenticated_HubLanding_SignUpLinkCaption"
            mode="dangerFilled"
            size="large"
            testId={testId}
            onClick={redirectToSignUp}
        />
    );
};
